// extracted by mini-css-extract-plugin
export default {"cont":"Confirm_cont__mKMcT","title":"Confirm_title__rAqiz","btnCont":"Confirm_btnCont__xl2Vv"};